document.addEventListener("DOMContentLoaded", function () {
  // Fetch the new CSRF token
  fetch('/dynamic', {
    headers: {
      'Accept': 'application/json',
    }
  }).then(response => response.json())
    .then(data => {
      if (data.csrf && data.csrf.name && data.csrf.value) {
        document.querySelectorAll('form.freeform-form input[name="CRAFT_CSRF_TOKEN"]')
          .forEach(input => {
            input.value = data.csrf.value;
          });
      }
    }).catch(error => console.error("CSRF update error:", error));
});